import { colors } from '../../colors';
var input = {
  textColor: colors.onyx
};
export default input;